import React from "react";

export default function Index({
  children,
  isHandleOnClick,
  name,
  id,
  style = {},
  className = "",
  disabled = false,
}) {
  function handleOnClick() {
    if (isHandleOnClick) {
      isHandleOnClick();
    }
  }

  // console.log('==handleOnClick==', { isHandleOnClick, name, id, style }, "children", children);

  return (
    <>
      <button
        name={name || ""}
        style={style || {}}
        id={id || ""}
        className={className || ""}
        onClick={handleOnClick}
        disabled={disabled}
      >
        {children}
      </button>
    </>
  );
}
